<div class="p-8">
  <h1 class="text-3xl font-bold text-gray-900 mb-6">{{ isEdit ? 'Edit Profile' : 'Add New Profile' }}</h1>

  <div class="bg-white rounded-lg shadow p-6">
    <form [formGroup]="profileForm" (ngSubmit)="onSubmit()" class="space-y-4">

      <!-- Name, Title + Image Preview -->
      <div class="flex flex-col md:flex-row gap-6">
        <div class="flex-1 space-y-4">
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium mb-1">First Name <span class="text-red-500">*</span></label>
              <input 
                type="text" 
                formControlName="firstName"
                class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                [class.border-red-500]="profileForm.get('firstName')?.invalid && profileForm.get('firstName')?.touched"
              >
              <div *ngIf="profileForm.get('firstName')?.invalid && profileForm.get('firstName')?.touched" class="text-red-500 text-sm mt-1">
                First name is required
              </div>
            </div>
            <div>
              <label class="block text-sm font-medium mb-1">Surname <span class="text-red-500">*</span></label>
              <input 
                type="text" 
                formControlName="surname"
                class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                [class.border-red-500]="profileForm.get('surname')?.invalid && profileForm.get('surname')?.touched"
              >
              <div *ngIf="profileForm.get('surname')?.invalid && profileForm.get('surname')?.touched" class="text-red-500 text-sm mt-1">
                Surname is required
              </div>
            </div>
          </div>

          <div>
            <label class="block text-sm font-medium mb-1">Job Title</label>
            <input 
              type="text" 
              formControlName="title"
              class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
          </div>

        </div>

        <!-- Profile Image Preview -->
        <div class="flex-shrink-0 flex flex-col items-center md:items-start">
          <div class="w-40 h-40 bg-gray-200 rounded-lg flex items-center justify-center overflow-hidden">
            <img *ngIf="profileForm.get('image')?.value" [src]="profileForm.get('image')?.value" alt="Profile preview" class="w-full h-full object-cover">
            <svg *ngIf="!profileForm.get('image')?.value" class="w-16 h-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
            </svg>
          </div>
          <button type="button" (click)="uploadPhoto()"
            class="mt-2 w-40 px-3 py-2 bg-white text-gray-700 rounded border border-gray-300 text-sm hover:bg-gray-50 flex items-center justify-center space-x-1">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path></svg>
            <span>Upload Photo</span>
          </button>
        </div>
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">Bio <span class="text-red-500">*</span></label>
        <app-tiptap-editor
          formControlName="text">
        </app-tiptap-editor>
        <div *ngIf="profileForm.get('text')?.invalid && profileForm.get('text')?.touched" class="text-red-500 text-sm mt-1">
          Bio is required
        </div>
      </div>

      <p class="text-sm text-gray-500"><span class="text-red-500">*</span> Required fields</p>

      <h3 class="text-lg font-semibold mt-6 mb-4">Social Media</h3>
      <div formGroupName="social" class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Facebook</label>
          <input type="url" formControlName="facebook" class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="https://facebook.com/...">
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Instagram</label>
          <input type="url" formControlName="instagram" class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="https://instagram.com/...">
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">LinkedIn</label>
          <input type="url" formControlName="linkedIn" class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="https://linkedin.com/in/...">
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">X</label>
          <input type="url" formControlName="twitter" class="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" placeholder="https://x.com/...">
        </div>
      </div>

      <div class="flex space-x-2 pt-6">
        <button 
          type="submit" 
          [disabled]="profileForm.invalid"
          class="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:bg-gray-300"
        >
          {{ isEdit ? 'Update Profile' : 'Create Profile' }}
        </button>
        <button 
          type="button" 
          (click)="onCancel()"
          class="bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>
